<template>
    <input-text v-bind="$attrs"
      ref="campo"
      v-model="model"
      v-mask="['##.###-###']"
      maxlength="20"
      format="cep"
      type="tel"
      :cep-invalido="invalido"
      v-on="listeners">
      <template v-for="(_, slotName) in $scopedSlots" v-slot:[slotName]="context">
        <slot :name="slotName" v-bind="context" />
      </template>
      <template v-for="(_, name) in $slots" v-slot:[name]>
        <slot :name="name" />
      </template>
    </input-text>
  </template>

<script>
export default {
  props: {
    value: null,
    modelEndereco: { type: Object, default: null },
    modelNames: {
      type: Object,
      default: () => {
        return {
          CEP: 'CEP',
          logradouro: 'logradouro',
          bairro: 'bairro',
          uf: 'uf',
          localidade: 'localidade',
          numero: 'numero',
          complemento: 'complemento'
        }
      }
    },
    dadosViaCep: { type: Boolean, default: false },
    disableFields: { type: Boolean, default: true }
  },
  data () {
    return {
      invalido: false,
      listeners: {},
    }
  },
  methods: {
    changeDefault: function (value) {
      if (!['', true].some(p => p === this.$attrs['disable-auto-change'])) {
        this.change(value)
      } else { this.$emit('change', value) }
    },
    change (value, callback) {
      const th = this
      let isValid = false
      if (value && th.$api.UI.Format.SomenteNumeros(value).length === 8) {
        th.invalido = false
        th.$api.UI.ShowLoading()
        th.$api.CEP.buscarCep(th.$api.UI.Format.SomenteNumeros(value)).then(
          function (response) {
            th.$api.UI.HideLoading()
            if (response.erro) {
              if (!(th.$attrs['hide-error-alert'] === '' || th.$attrs['hide-error-alert'])) { th.$api.UI.ShowAlert('', 'Endereço não Localizado pelo CEP') }
              th.$emit('change', value, false)
              if (callback) { callback(isValid) }
            } else {
              if (th.modelEndereco) {
                th.$set(th.modelEndereco, th.modelNames.logradouro, response.logradouro)
                th.$set(th.modelEndereco, th.modelNames.bairro, response.bairro)
                th.$set(th.modelEndereco, th.modelNames.uf, response.uf)
                th.$set(th.modelEndereco, th.modelNames.localidade, response.localidade)
                th.$nextTick(() => {
                  try {
                    let input = th.$el.closest('.row').querySelector('[cep-numero] input')
                    if (!input) { input = th.$el.closest('.row').parentElement.querySelector('[cep-numero] input') }
                    input.focus()
                  } catch {}
                })
                if (th.disableFields && response.logradouro && response.bairro && response.uf && response.localidade) {
                  th.$emit('update:dadosViaCep', true)
                }
              }
              if (callback) {
                isValid = true
                callback(isValid)
              }
              th.$emit('change', value, true)
            }
          }
        ).catch((error) => {
          th.$api.UI.HideLoading()
          console.log(error)
        })
      } else {
        if (th.$attrs['clear-model']) {
          th.$set(th.modelEndereco, th.modelNames.logradouro, null)
          th.$set(th.modelEndereco, th.modelNames.bairro, null)
          th.$set(th.modelEndereco, th.modelNames.uf, null)
          th.$set(th.modelEndereco, th.modelNames.localidade, null)
          th.$set(th.modelEndereco, th.modelNames.numero, null)
          th.$set(th.modelEndereco, th.modelNames.complemento, null)
        }
        th.invalido = true
        th.$emit('change', value, false)
        if (callback) { callback(isValid) }
      }
    }
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  created () {
    this.listeners = { ...this.$listeners, change: this.changeDefault }
  }
}
</script>
